@keyframes infiniteRotation {
  0%{
    transform: rotate(0deg);
    //background-color: blueviolet;
  }
  50%{
    transform: rotate(180deg);
    //background-color: aqua;
  }
  100%{
    transform: rotate(360deg);
    //background-color: blue;
  }
}

.roundIcon
{
  background-color: var(--beigelight);
  display: inline-flex;
  border-radius: 50%;
  color: var(--beigedarker);
  justify-content: center;
  align-items: center;
  height: 36px;
  width: 36px;

    &.dark {
        background-color: var(--beigedarker);
        color: white;
    }

  &.rotating {
    animation: infiniteRotation 4s linear infinite;
  }
}
